<template>
  <div class="protocol container">
    <div class="item">
      用户进入平台后，勾线“我已阅读并同意《隐私条款》和《免责声明》”，即表示用户与长城新媒体集团冀云客户端达成协议，自愿接受本服务条款的所有内容。
    </div>
    <div class="bigtitle">用户隐私保护声明</div>
    <div class="title">
      《冀云》充分尊重和保护所有用户的个人隐私权，不遗余力地保护您的个人信息，同时会持续完善隐私保护功能，特发表如下声明：
    </div>
    <p>
      1.妥善保管用户信息。有关技术上的信息，当用户使用本应用，我们收集和汇总诸如哪些功能被使用，程序运行记录等信息，获得的信息将被用于趋势分析及统计，提升用户体验。有关个人身份的信息，本应用只收集由用户在自主意愿下所填写、传送并愿意由本应用所使用的资料，例如：姓名、地址、电子邮件信箱等。使用方式包括不限于利用资料来了解用户对应用的意见与看法，或参加本应用发起的各项活动等。所收集的证实个人身份的信息存储在加密服务器上，我们对这些服务器采取安全保护措施，从而保护这些服务器和用户个人信息。
    </p>
    <p>
      2.未经授权不共享或公开任何信息。我们会高度重视您的隐私信息保护，未经您的同意或按政府主管部门的强制性要求或司法裁定，不会与任何第三方分享、公开您的信息；未经您的同意，不能在透露个人资料地基础上为您提供所要求的产品和服务；除非另行通知您，不向代表我们提供产品或服务的公司提供任何身份识别资料；如果您违反了本应用服务条款、任何其它产品及服务的使用规定，或者有关的法律法规，我们会听从法庭传票、法律命令或遵循法律程序。
    </p>
    <p>
      3.保障您的个人信息处置权利。除法律法规规定的例外情况外，客户端支持用户访问、修改和删除其个人信息以使其有效，用户能在任何时候非常容易地获取并修改其个人信息。
    </p>
    <p>
      4.隐私声明的修订。根据需要，将随时修改本隐私声明。未来任何条款如有更新，我们将不主动提醒用户，亦不会回溯产品在之前所发生的情形，同时不会改变我们对于之前所收集的资料之处理方式。
    </p>
    <div class="bigtitle">免责声明</div>
    <p>
      用户明确同意使用冀云客户端相关功能的风险由用户个人承担。冀云客户端明确表示不提供任何类型的担保，不论是明确的或隐含的，但是对商业性的隐含担保，特定目的和不违反规定的适当担保除外。冀云客户端不担保服务一定能满足用户端要求，也不担保服务不会受中断，对服务的及时性、安全性、真实性、出错发生都不做担保。用户理解并接收下载或通过冀云客户端产品服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其他任何风险。
    </p>
    <p>
      用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。用户承诺：
    </p>
    <p>
      （1）在冀云客户端的网页上发布信息时必须符合中国有关法规，不得在冀云客户端的网页上或利用冀云客户端的服务制作、复制、发布、传播违反中国法律法规的内容。
    </p>
    <p>
      （2）在冀云客户端的网页上发布信息或者利用冀云客户端的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。
    </p>
    <p>
      （3）不得以任何方式干扰冀云客户端的服务。
    </p>
    <p>
      （4）遵守冀云客户端的所有其他规定和程序。
    </p>
    <p style="text-indent: 28px;">
      用户须对自己在使用冀云客户端服务过程中的行为承担法律责任。
    </p>
    <div class="footer">本声明生效日期：2021年4月10日</div>
    <SlideBar />
  </div>
</template>
<script>
import SlideBar from "@/components/SlideBar";
export default {
  name: "protocol",
  components: { SlideBar },
  data() {
    return {};
  },
};
</script>
<style scoped lang="scss">
.protocol {
  padding: 40px 20px;
  box-sizing: border-box;
  text-align: left;
  line-height: 2;
  height: auto;
  min-height: 100vh;
  .item {
    font-size: 14px;
    text-indent: 28px;
  }
  .bigtitle {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin: 10px 0;
  }
  .title {
    font-size: 14px;
  }
  p {
    font-size: 14px;
    color: #333;
  }
  .footer {
    font-size: 12px;
    color: #333;
    margin-top: 30px;
    text-align: center;
  }
}
</style>
